import { HeroSection } from './HeroSection.tsx'
import { FeaturesSection } from './FeaturesSection.tsx'
import { PricingSection } from './PricingSection.tsx'

export function HomePage() {
  return (
    <>
      <HeroSection />
      <FeaturesSection />
      <PricingSection />
    </>
  )
}
